import React from 'react';

const TooltipHeaderCell = ({
 onClick, title, tooltip, children,
}) => (
  <span className='k-cell-inner'>
    <span className='k-link' onClick={onClick}>
      <span className='k-column-title' title={tooltip}>{title}</span>
      {children}
    </span>
  </span>
);

export default TooltipHeaderCell;
